import React, { useContext } from "react";
import {
  Button,
  ListItem,
  makeStyles,
  Collapse,
  Badge,
  Box,
} from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import { AuthContext, BadgeContext } from "../context";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

export default function NavItem({
  className,
  href,
  icon: Icon,
  title,
  collapse,
  options,
  badgeReports,
  ...rest
}) {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { signOut } = useContext(AuthContext);
  const { badgeState } = useContext(BadgeContext);

  const redirect = (href) => {
    if (title === "Salir") {
      signOut();
    } else {
      history.push(href);
    }
  };

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };
  

  return !collapse ? (
    <ListItem className={classes.item} disableGutters {...rest}>
      <Button
        className={location.pathname === href ? classes.active : classes.button}
        onClick={() => redirect(href)}
      >
        {Icon && (
          <Box className={classes.icon}>
            <Icon />
          </Box>
        )}
        <span className={classes.title}>{title}</span>
        {title === "Reportes" && (
          <Badge color="primary" badgeContent={badgeState.quantity} showZero />
        )}
      </Button>
    </ListItem>
  ) : (
    <>
      <ListItem className={classes.item} disableGutters {...rest}>
        <Button
          className={
            location.pathname === href ? classes.active : classes.button
          }
          onClick={handleClick}
        >
          {Icon && (
            <Box className={classes.icon}>
              <Icon />
            </Box>
          )}{" "}
          <span className={classes.title}>{title}</span>
          {open ? <ExpandLess /> : <ExpandMore />}
        </Button>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {options.map((option, index) => (
          <ListItem
            className={classes.item}
            disableGutters
            key={index}
            style={{ paddingLeft: 12 }}
            {...rest}
          >
            <Button
              className={
                location.pathname === option.href
                  ? classes.active
                  : classes.button
              }
              onClick={() => redirect(option.href)}
            >
              {option.icon && (
                <Box className={classes.icon}>
                  <option.icon />
                </Box>
              )}
              <span className={classes.subtitle}>{option.title}</span>
            </Button>
          </ListItem>
        ))}
      </Collapse>
    </>
  );
}

const useStyles = makeStyles((theme) => ({
  item: {
    display: "flex",
    paddingTop: 0,
    paddingBottom: 0,
  },
  button: {
    // color: theme.palette.text.secondary,
    // fontWeight: theme.typography.fontWeightMedium,
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "10px 20px",
    textTransform: "none",
    width: "100%",
  },

  title: {
    marginRight: "auto",
    fontSize: "0.875rem",
    color: theme.palette.text.primary,
    width: "fit-content",
    textAlign: "left",
    whiteSpace: "break-spaces",
  },
  subtitle: {
    marginRight: "auto",
    fontSize: "0.875rem",
    color: theme.palette.grey[800],
    width: "fit-content",
    textAlign: "left",
    whiteSpace: "break-spaces",
  },
  active: {
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
    justifyContent: "flex-start",
    letterSpacing: 0,
    padding: "10px 20px",
    textTransform: "none",
    width: "100%",
    backgroundColor: `hsl(from ${theme.palette.primary.main} h s calc(l + 66))`,
    "& $title, & $subtitle": {
      fontWeight: "bold",
      color: theme.palette.primary.main,
    },
    "& $icon": {
      color: theme.palette.primary.main,
    },
  },
  icon: {
    color: theme.palette.grey[500],
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // width: 30,
    margin: "0 12px 0 0",
  },
}));
